import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      width: '100%',
      background: theme.palette.secondary.light,
      [theme.breakpoints.up('md')]: {
        width: 900,
      },
      '&:focus': {
        outline: 'none',
      },
    },
    headerWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: SMALL_MARGIN,
    },
    title: {
      fontSize: 24,
      lineHeight: 1.2,
      fontWeight: 'bold',
      marginBottom: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
      },
    },
    closeIcon: {
      width: 14,
      height: 14,
      cursor: 'pointer',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    certificateImgWrapper: {
      flex: 1,
      position: 'relative',
      marginBottom: SMALL_MARGIN,
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        marginRight: SMALL_MARGIN,
        marginBottom: 0,
      },
    },
    certificateImgWrapperWithBg: {
      borderRadius: 5,
    },
    certificateImg: {
      borderRadius: 5,
      width: '100%',
    },
    buttonsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'stretch',
      '& button, & a': {
        marginBottom: 6,
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
    shareButtonWrapper: {
      '&:focus': {
        outline: 'none',
      },
    },
    shareButton: {
      cursor: 'pointer',
      marginBottom: 6,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    teamsShareOriginal: {
      display: 'none',
    },
  }),
);

export default useStyles;
